var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',{attrs:{"title":'Arbeitshilfen',"active":""}},[_c('div',{staticClass:"modal-scrolled-content"},[_c('Arbeitshilfen')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }